var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF7900",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8333V9.5M12.4167 15.75C12.4167 15.9801 12.2301 16.1667 12 16.1667C11.7699 16.1667 11.5833 15.9801 11.5833 15.75M12.4167 15.75C12.4167 15.5199 12.2301 15.3333 12 15.3333C11.7699 15.3333 11.5833 15.5199 11.5833 15.75M12.4167 15.75H11.5833M17.9663 10.1541V10.1541C16.5756 7.67074 15.8803 6.42906 15.1069 5.81574C13.2871 4.37242 10.7129 4.37242 8.89305 5.81574C8.11973 6.42906 7.42439 7.67074 6.03371 10.1541V10.1541C4.69679 12.5414 4.02833 13.7351 3.90481 14.6955C3.6144 16.9532 4.88566 19.1221 6.99745 19.9719C7.89571 20.3333 9.2638 20.3333 12 20.3333V20.3333C14.7362 20.3333 16.1043 20.3333 17.0025 19.9719C19.1143 19.1221 20.3856 16.9532 20.0952 14.6955C19.9717 13.7351 19.3032 12.5414 17.9663 10.1541Z",
    stroke: "#FF7900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.b4d35abe971e640e696e178e89550577.svg";
export { ForwardRef as ReactComponent };